import { WC_API_URL,WC_API_HEADER_KEY } from '../config/config'
import axios from "axios"

export const ReferralPartnerUpdateAPI = async (id,data,isReferral) => {
   try {
     let res = ''
     if(isReferral){
         res = await axios.put(`${WC_API_URL}/referralPartners/${id}`,
         data,
         {
            headers:{
               'x-internal-key' : WC_API_HEADER_KEY
            }
         }
      )
     }
     else{
         res = await axios.put(`${WC_API_URL}/partners/${id}`,
         data,
         {
            headers:{
               'x-internal-key' : WC_API_HEADER_KEY
            }
         }
      )
     }
     return {success:true,res}
   } catch (error) {
      return {
            success:false,
            message:error?.response?.data?.message,
            error
        }
   }
}